import border from '../../border';

const dark = (params) => border.active.dark(params);

export default dark;
